import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild
} from '@angular/core';
import {LocalStorageService, SessionStorageService} from 'angular-web-storage';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {NotifierWrapService} from '../../services/notifier-wrap.service';

import {TelegramService} from '../../pages/page-telegram/telegram.service';
import {finalize, from, ReplaySubject, Subject, takeUntil, throttleTime} from 'rxjs';
import {ModalService} from '../../services/modal.service';
import {TabsetComponent} from 'ngx-bootstrap/tabs';
import {ViewportScroller} from '@angular/common';
import {ActivatedRoute, NavigationStart, Router} from '@angular/router';
import {debounceTime, filter} from 'rxjs/operators';
import {NzModalService} from 'ng-zorro-antd/modal';
import {AllService} from '../../services/all.service';
import { Chat, IMessengerConnector, Message, SendMessage } from '../../types/all.type';
import {SnotifyPosition, SnotifyService} from 'ng-snotify';
import {AllMessengersService} from '../../pages/page-start/all-messengers.service';
import {DropzoneComponent, DropzoneConfig} from 'ngx-dropzone-wrapper';
import {isMobile, log} from '../../functions';
import {MusicPlayerService} from '../../services/music-player.service';
import {InterfaceService} from '../../services/interface.service';
import {CallService} from '../../services/call.service';
import {SenderService} from '../../services/sender.service';
import {AppService} from '../../services/app.service';
import {NZ_CAROUSEL_CUSTOM_STRATEGIES, NzCarouselFlipStrategy, NzCarouselTransformNoLoopStrategy} from 'ng-zorro-antd/carousel';
import {DcService} from '../../services/dc.service';
import {ToursService} from '../../services/tours.service';

@Component({
  selector: 'app-chat-show',
  templateUrl: './chat-show.component.html',
  styleUrls: ['./chat-show.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NZ_CAROUSEL_CUSTOM_STRATEGIES,
      useValue: [
        {name: 'transform-no-loop', strategy: NzCarouselTransformNoLoopStrategy},
        {name: 'flip', strategy: NzCarouselFlipStrategy}
      ]
    }
  ]
})
export class ChatShowComponent implements OnInit, OnDestroy {
  public strategy = 'transform-no-loop';
  public array = [1, 2, 3, 4];
  public isLoadError = false;
  @Output() onNewChat = new EventEmitter<any>();
  @Output() onOpenProfile = new EventEmitter<any>();
  showDetailInfoId: number | string;
  public isRecord = false;
  public isLoaded = false;
  smilePickerShow = false;
  @Input() id: any;
  @Input() Service: IMessengerConnector;
  arReplaces: any = {};
  FormMessage: UntypedFormGroup;
  uploadFile: any;
  isSending = false;
  _isFocusTextarea = false;
  _isHoverTextarea = false;
  public openChat: Chat;
  myDropzone: any;
  @ViewChild('fileSelect') fileSelect: ElementRef;
  @ViewChild('dropzoneTemplate') dropzoneTemplate: ElementRef;
  @ViewChild('dropzoneForm') dropzoneForm: DropzoneComponent;
  @ViewChild('dropzonePreviews') dropzonePreviews: ElementRef;
  @ViewChild('mediaTabs', {static: false}) mediaTabs: TabsetComponent;
  arFilesObj: any = [];
  arFiles: any = {};
  loadHistoryCompleted = false;
  public messageLastDate: number;
  @ViewChild('scrollContainer') scrollContainer: ElementRef;
  @ViewChild('messageText') messageText: ElementRef;
  arSelectMessages: Message[] = [];
  @ViewChild('deleteModalContent', {read: TemplateRef})
  deleteModalContent: TemplateRef<any>;
  public resultSpellCheck: any = [];
  public spellCheckText: string;
  getSpellTimeout: NodeJS.Timeout;
  private destroy$: Subject<void> = new Subject();
  detectChanges$: ReplaySubject<string> = new ReplaySubject();
  dropzoneConfig: DropzoneConfig = {
    assign(config?: any, target?: any): void {}
  };
  arSearchMembers: any = [];
  selectUsername = '';
  selectUsernameIndex = 0;
  isMobile = isMobile();

  @HostListener('window:focus', ['$event'])
  onWindowFocus(event: FocusEvent) {
    this.cd.detectChanges();
  }

  @HostListener('window:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    if (event.getModifierState && event.getModifierState('Control') && event.keyCode === 70) {
      this.searchToggle();
    }
    log('onKeyDown: ' + event.key);
    if (event.key === 'Escape') {
      let exist = false;
      this.interfaceService.showMobileHome = false;
      if (this.cancelSpellCheck()) {
        exist = true;
      }
      if (this.closeSenderForm()) {
        exist = true;
      }
      if (this.cancelForward()) {
        exist = true;
      }
      if (this.cancelReply()) {
        exist = true;
      }
      if (this.cancelSearchMembers()) {
        exist = true;
      }
      if (this.editCancel()) {
        exist = true;
      }
      if (this.clearSelectMessages()) {
        exist = true;
      }
      if (!exist && !this.allService.isMediaFullScreen()) {
        this.closeChat();
      }
    }
    if (this.allService.isElectron()) {
      if (event.key === 'F5') {
        location.href = '';
      }
      if (event.key === 'F12') {
        this.allService.openDevTools();
      }
    }
  }

  constructor(
    public toursService: ToursService,
    private dcService: DcService,
    public senderService: SenderService,
    public musicPlayerService: MusicPlayerService,
    public allMessengersService: AllMessengersService,
    private snotifyService: SnotifyService,
    private modal: NzModalService,
    private viewportScroller: ViewportScroller,
    private route: ActivatedRoute,
    private router: Router,
    public allService: AllService,
    private cd: ChangeDetectorRef,
    public modalService: ModalService,
    public telegramService: TelegramService,
    public notifierWrapService: NotifierWrapService,
    public local: LocalStorageService,
    public session: SessionStorageService,
    public interfaceService: InterfaceService,
    public callService: CallService,
    public appService: AppService
  ) {
    this.dcService.detectChangesConnect$.subscribe(() => {
      this.detectChanges$.next('detectChangesConnect$');
    });
    this.interfaceService.$onCancelAddSender.subscribe(() => {
      this.closeSenderForm();
    });
    this.dcService.detectChangesConnect$.subscribe(() => {
      this.detectChanges$.next('detectChangesConnect$');
    });
    /*this.dropzoneConfig.url = async (files: File[]) => {
      return new Promise(resolve => {
        this.Service.getUploadUrl(this.Service.openChatId).subscribe((v) => {
          resolve(v.uploadUrl);
        });
      });
    }*/
    // this.appService.openChat(id, this.Service.type);

    this.handleOpenChatFromUrl();

    this.router.events
      .pipe(
        takeUntil(this.destroy$),
        filter((event) => event instanceof NavigationStart)
      )
      .subscribe((event) => {
        setTimeout(() => {
          if (this.router.url === '/') {
            if (!this.allService.isMediaFullScreen()) {
              this.closeChat();
            }
          }
        }, 5);
      });
  }

  addMessage(result) {
    if (result.id) {
      result.show = true;
      this.Service.arHistory.push(result);
      this.interfaceService.scrollChat$.next();
    }
  }

  enterMessage(event) {
    event.preventDefault();
    this.Service.message = this.Service.message.replace(/\n+$/m, '');
    if (this.Service.editMessage) {
      this.saveMessage();
    } else {
      this.sendMessage(event);
    }
  }

  ngOnInit(): void {
    // TODO optimise this.cd.detach();
    if (localStorage.getItem('message-animate')) {
      this.interfaceService.isMessageInputAnimate = false;
    }
    this.interfaceService.showDetail$.pipe(takeUntil(this.destroy$)).subscribe((id) => {
      if (id) {
        this.showDetailInfoId = id;
      }
      this.detectChanges('showDetail$');
    });
    this.interfaceService.showTabsInput$.pipe(throttleTime(100), takeUntil(this.destroy$)).subscribe((val) => {
      this.detectChanges('showTabsInput$');
    });
    /*this.allMessengersService.setService$.pipe(throttleTime(100), takeUntil(this.destroy$)).subscribe((event) => {
      this.Service = this.allMessengersService.Service;
      this.detectChanges$.next('allMessengersService.setService$');
    });*/
    this.initForm();
    this.initDropdown();
    this.dcService.detectChanges$.pipe(
      filter(v => v === 'chat-show'), debounceTime(100), takeUntil(this.destroy$)
    ).subscribe((component) => {
      this.detectChanges$.next('dcService.detectChanges$');
    });
    this.interfaceService.openChat$.pipe(takeUntil(this.destroy$)).subscribe((event) => {
      if (!event) {
        this.Service._openChatId = false;
        delete this.Service._openChat;
      }
      this.cancelReply();
      this.cancelForward();
      this.interfaceService._showMobileHome = false;
      this.detectChanges('openChat$');
      /*this.dcService.detectChanges$.next('app-root');
      this.dcService.detectChanges$.next('page-start');*/
      if (!event) {
        return;
      }
      this.init();
      this.focusDesktopTextarea();
    });
    this.interfaceService.focusTextArea$.pipe(takeUntil(this.destroy$)).subscribe((val) => {
      if (val) {
        this.focusTextArea();
      }
    });

    this.interfaceService.positionTextArea$.pipe(takeUntil(this.destroy$)).subscribe((val) => {
      if (this.interfaceService.messageTextareaType !== 'editor' && val) {
        setTimeout(() => {
          this.messageText.nativeElement.setSelectionRange(val + 1, val + 1);
          this.setTextAreaPosition();
        }, 50);
      }
    });
    this.allMessengersService.getProfile()
      .pipe(
        debounceTime(500),
        finalize(() => {
          this.cd.detectChanges();
        }),
      )
      .subscribe(() => {
        this.Service.isLoadedProfile = true;
        this.detectChanges$.next('getProfile ALL');
      });
    this.detectChanges$.pipe(debounceTime(500)).subscribe((text) => {
      this.detectChanges('$ ' + text);

    });
    this.cd.detectChanges();
  }

  detectChanges(text: string): void {
    if (this.interfaceService.isFocused()) {
      log('ChatShowComponent detectChanges', text);
      this.cd.detectChanges();
    }
  }

  init() {
    this.switchDraftMessage(this.Service.openChatId);
    this.onCloseVoice();
    this.cancelSpellCheck();
    this.cancelSearchMembers();
    this.Service.editMessage = false;
    if (this.Service.openChatId) {
      setTimeout(() => {
        this.arSelectMessages = [];

        this.showDetailInfoId = this.Service.openChatId;
        // this.showDetailInfo = false;
        this.initDropdown();
      }, 300);
    } else {
      this.Service.arHistory = [];
      // delete this.myDropzone;
    }
    this.detectChanges$.next('init');
  }

  focusTextArea() {
    if (this.allService.permissionsCheck('can_send_messages', this.Service)) {
      try {
        this.messageText.nativeElement.focus();
      } catch (e) {
      }
    }
  }

  saveDraftMessage() {
    if (!this.Service.editMessage) {
      this.allService.savedDraft[this.Service.openChatId] = {
        message: this.Service.message
      };
      this.allService.saveDraft();
    }
  }

  switchDraftMessage(id) {
    // Save draft
    if (this.allService.lastChatId) {
      if (this.myDropzone) {
        this.myDropzone.removeAllFiles();
      }
      this.allService.savedDraft[this.allService.lastChatId] = {
        message: this.Service.message,
        files: this.arFilesObj
      };
      this.arFilesObj = [];
      if (this.Service.replyMessage) {
        this.allService.saveReplyDraft(this.allService.lastChatId, this.Service.replyMessage);
      }
    }
    // Restore draft
    this.Service.replyMessage = this.allService.restoreReplyDraft(id);
    if (this.allService.savedDraft[id]) {
      // this.myDropzone.addFile(item.getAsFile());
      this.Service.message = this.allService.savedDraft[id].message;
      /*this.arFilesObj = this.savedDraft[id].files;

            for (let i = 0; i < this.arFilesObj.length; i++) {
              setTimeout(() => {
                //this.myDropzone.addFile(this.arFilesObj[i]);
              }, 1500)
              this.arFilesObj.splice(i, 1);
            }*/
    } else {
      this.interfaceService.clearTextArea$.next();
    }
    this.allService.saveDraft();
  }

  closeSenderForm(): boolean {
    // this.Service.editMessage = false;
    this.senderService.senderAddForm = false;
    this.detectChanges('closeSenderForm');
    this.editCancel();
    this.senderService.resetForm();
    return !this.senderService.senderAddForm;
  }

  cancelSpellCheck(): boolean {
    if (this.resultSpellCheck?.length > 0) {
      this.resultSpellCheck = [];
      this.spellCheckText = '';
      this.detectChanges('cancelSpellCheck');
      return true;
    }
  }

  spellCheck(timeout = 800) {
    if (!this.spellCheckText) {
      timeout = 100;
    }
    clearTimeout(this.getSpellTimeout);
    this.getSpellTimeout = setTimeout(() => {
      if (!this.Service.message || this.Service.message?.length < 3 || this.allService.isTouchDevice) {
        this.cancelSpellCheck();
        return;
      }
      this.allService.getSpellCheck(this.Service.message?.replace(/(<([^>]+)>)/gi, '')).subscribe((res) => {
        this.resultSpellCheck = res;
        this.spellCheckText = this.Service.message?.toString();
        res.forEach((v) => {
          if (v.s?.length > 0 && v.s[0]?.length > 0) {
            this.spellCheckText = this.spellCheckText.replace(v.word, `<i>${v.s[0]}</i>`);
          }
        });
        this.detectChanges('getSpellCheck');
      });
    }, timeout);
  }

  clickSpellItem($event): void {
    if ($event?.path?.length > 0) {
      const spellItem = $event?.path[0];
      if (spellItem?.localName === 'i') {
        const findSpell = this.resultSpellCheck.find((v) => v.s[0] === spellItem.innerHTML);
        if (findSpell) {
          const firstSpace = findSpell.pos !== 0 ? ' ' : '';
          const lastSpace = findSpell.pos + findSpell.len !== this.Service.message?.length ? ' ' : '';
          // @ts-ignore
          this.Service.message = this.Service.message.replaceAll(
            firstSpace + findSpell.word + lastSpace,
            firstSpace + spellItem.innerHTML + lastSpace
          );
          this.spellCheck(0);
        }
      }
    }
  }

  replaceAllSpell(): void {
    let newString = this.Service.message;
    this.resultSpellCheck.forEach((findSpell) => {
      const firstSpace = findSpell.pos !== 0 ? ' ' : '';
      const lastSpace = findSpell.pos + findSpell.len !== this.Service.message?.length ? ' ' : '';
      // @ts-ignore
      newString = newString?.replaceAll(
        firstSpace + findSpell.word + lastSpace,
        firstSpace + findSpell.s[0] + lastSpace
      );
    });
    this.Service.message = newString;
    this.cancelSpellCheck();
  }

  focusDesktopTextarea(): void {
    if (!this.isMobile) {
      setTimeout(() => {
        this.focusTextArea();
      }, 150);
      this.spellCheck();
    }
  }

  textareaMouseenter(): void {
    if (this.isPreviewTextarea) {
      this._isHoverTextarea = true;
      if (!this.interfaceService._supportsEmoji) {
        this.detectChanges$.next('textareaMouseenter');
      }
    }
  }

  textareaMouseout(): void {
    this._isHoverTextarea = false;
    if (!this.interfaceService._supportsEmoji) {
      this.detectChanges$.next('textareaMouseout');
    }
  }

  textareaInput($event): void {
    if (!this.Service.message) {
      return;
    }
    this.onPasteLinkMedia($event);
    this.selectUsernameIndex = 0;
    this.saveDraftMessage();
    this.setTextAreaPosition();
    if (!this.allService.isTouchDevice) {
      this.spellCheck();
    }
    // log('!!!!!!!!!!!!!!!', this.Service.message);
    let lastWord: any = this.Service.message?.split(' ');
    lastWord = lastWord[lastWord?.length - 1];
    if (lastWord && lastWord.includes('@')) {
      this.selectUsername = lastWord.match(/@([^ ]*)/)[1]?.toLowerCase();
      if (this.selectUsername) {
        this.arSearchMembers = this.Service.openChat.members?.filter(
          (v) =>
            v?.username?.includes(this.selectUsername) ||
            v?.name?.first?.toLowerCase()?.includes(this.selectUsername) ||
            v?.name?.last?.toLowerCase()?.includes(this.selectUsername) ||
            v?.phone_number?.includes(this.selectUsername)
        ) || [];
      } else {
        this.arSearchMembers = this.Service.openChat.members;
      }
      if (this.arSearchMembers?.length > 0) {
        this.arSearchMembers = this.arSearchMembers.filter((v) => v?.username !== this.Service.arProfile?.username);
      }
      this.detectChanges('textareaInput');
    } else {
      this.cancelSearchMembers();
    }
  }

  selectMember(member: any): void {
    if (this.selectUsername) {
      log('Replace', this.selectUsername, member);
      this.Service.message = this.Service.message.replace(this.selectUsername, (member?.username || member?.name?.first) + ' ');
    } else {
      log('Add end', member);
      // TODO fix name
      this.Service.message += (member?.username || member?.name?.first) + ' ';
    }
    this.interfaceService.focusTextArea$.next(true);
    this.cancelSearchMembers();
  }

  cancelSearchMembers(): boolean {
    if (this.arSearchMembers?.length > 0) {
      this.arSearchMembers = [];
      this.detectChanges('cancelSearchMembers');
      return true;
    }
  }

  textareaFocus(): void {
    this.senderService.senderAddForm = true;
    if (this.isMobile) {
      this.interfaceService.showTabsInput$.next(false);
      this.isFocusTextarea = true;
    }
    this.detectChanges$.next('textareaFocus');
  }

  textareaEnter(e): void {
    if (this.arSearchMembers?.length > 0) {
      this.selectMember(this.arSearchMembers[this.selectUsernameIndex]);
    } else {
      this.enterMessage(e);
    }
    e.preventDefault();
  }

  isValidHttpUrl(str: string) {
    let url;

    try {
      url = new URL(str);
    } catch (_) {
      return false;
    }

    return url.protocol === 'http:' || url.protocol === 'https:';
  }

  async onPasteLinkMedia(e) {
    if (
      typeof this.Service.message === 'string' &&
      this.Service.message?.match(
        /\.(jpeg|jpg|gif|png|zip|doc|txt|svg|php|py|js|css|excel|rar|7z|tar|gz|docx|xls|xlsx|bmp)$/
      ) != null
    ) {
      const url = this.Service.message;
      if (this.isValidHttpUrl(url)) {
        const blob = await fetch(url).then((r) => r.blob());
        log(blob, url);
        this.Service.saveFile(blob).subscribe(
          (saveFile: any) => {
            if (saveFile) {
              saveFile.name = this.allService.basename(url, '.');
              if (!this.arFiles[saveFile.name]) {
                this.myDropzone.addFile(saveFile);
                if (this.allService.isTouchDevice) {
                  // this.sendMessage(e);
                }
                this.interfaceService.clearTextArea$.next();
                this.detectChanges$.next('onPasteLinkMedia');
              } else {
              }
            }
          },
          (error) => {
            this.interfaceService.errorHandling(error);
          }
        );
      } else {
        this.detectChanges('onPasteLinkMedia 2');
      }
    }
  }

  textareaPasted(e) {
    this.onPasteLinkMedia(e).then((r) => {
      log(r);
    });
  }

  textareaKeyUp(e: any): void {
    this.setTextAreaPosition();
    if (e.code === 'ArrowDown') {
      if (this.selectUsernameIndex < this.arSearchMembers?.length - 1) {
        this.selectUsernameIndex++;
      }
    }
    if (e.code === 'ArrowUp') {
      if (this.selectUsernameIndex > 0) {
        this.selectUsernameIndex--;
      }
    }
  }

  textareaFocusout(): void {
    // this.senderAddForm = false;
    this.isFocusTextarea = false;
  }

  get isPreviewTextarea() {
    return (
      !this.interfaceService._supportsEmoji &&
      !this.isMobile &&
      !this._isFocusTextarea &&
      !this._isHoverTextarea &&
      this.Service.message
    );
  }

  set isFocusTextarea(val) {
    this._isFocusTextarea = val;
    if (!this.interfaceService._supportsEmoji) {
      this.detectChanges$.next('isFocusTextarea');
    }
  }

  closeChat() {
    console.warn('Close chat');
    // window.history.back();
    delete this.Service._openChatId;
    this.interfaceService.openChat$.next(false);
    this.allService.isCloseChat = true;
    this.detectChanges('closeChat');
  }

  initForm() {
    this.FormMessage = new UntypedFormGroup({
      text: new UntypedFormControl(null, [Validators.required, Validators.minLength(1)])
    });
  }

  get arFilesCount(): number {
    return Object.keys(this.arFiles)?.length;
  }

  onUploadSuccess($event) {
    log('onUploadSuccess', $event);
    this.Service.saveFile($event).subscribe(
      (saveFile: any) => {
        log('saveFile', saveFile);
        this.arFiles[saveFile.name] = {
          date: new Date()
        };
        this.detectChanges('onUploadSuccess');
        $event[0].upload.uri = saveFile;
      },
      (error) => {
        this.interfaceService.errorHandling(error);
        this.myDropzone.removeFile($event[0]);
      }
    );
    // delete this.uploadFile;
    // this.detectChanges();
  }

  onUploadError($event) {
    log('onUploadError', $event);
  }

  onUploadInit($event) {
    this.myDropzone = $event;
    log('onUploadInit', $event);
  }

  onAddedFile(file: File) {
    this.Service.addedFile(file).subscribe(
      (data) => {
        this.dropzoneConfig.url = data.uploadUrl;
        log('Service.addedFile', data, this.Service);
      },
      (error) => {
        this.interfaceService.errorHandling(error);
      }
    );
    if (!this.arFiles[file.name]) {
      this.arFilesObj.push(file);
      this.detectChanges('onAddedFile');
    } else {
    }
    log('onAddedFile', file);
  }

  onSending($event) {
    log('sending', $event);
    this.uploadFile = $event[0];
    this.detectChanges('onSending');
  }

  onQueueComplete($event) {
    log('onQueueComplete', $event);
    delete this.uploadFile;
    this.detectChanges('onQueueComplete');
  }

  onRemovedFile($event) {
    log('onRemovedFile', $event);
    delete this.arFiles[$event.name];
    this.Service.deleteFile($event.upload.uri).subscribe(
      (result: any) => {
        // alert(file.upload.uri);
        delete this.arFiles[$event.upload.uri];
        this.detectChanges('onRemovedFile');
      },
      (error) => {
        // this.detectChanges();
        this.interfaceService.errorHandling(error);
      }
    );
  }

  initDropdown(): void {
    if (this.dropzonePreviews) {
      this.Service.getUploadUrl(this.Service.openChatId)
        .pipe(takeUntil(this.destroy$))
        .subscribe((data) => {
          // this.myDropzone = this.dropzoneForm.directiveRef.dropzone();
          // this.dropzoneConfig.autoQueue = false;
          this.dropzoneConfig.previewTemplate = this.dropzoneTemplate?.nativeElement?.innerHTML;
          const previewsContainer = this.dropzonePreviews.nativeElement;
          this.dropzoneConfig.url = data.uploadUrl;
          this.dropzoneConfig.method = data.method;
          this.dropzoneConfig.previewsContainer = previewsContainer;
          this.dropzoneConfig.clickable = this.fileSelect.nativeElement;
        });
      //
      document.onpaste = (event) => {
        // @ts-ignore
        const items: any = (event.clipboardData || event.originalEvent.clipboardData).items;
        from(items)
          .pipe()
          .subscribe((item: any) => {
            if (item.kind === 'file') {
              // adds the file to your dropzone instance
              const file = item.getAsFile();
              this.myDropzone.addFile(item.getAsFile(file));

              // this.myDropzone.enqueueFile(file);
              this.detectChanges('initDropdown');
            }
          });
      };
    }
  }

  editCancel(): boolean {
    if (this.Service.editMessage) {
      this.Service.message = this.Service.bufferMessage;
      delete this.Service.bufferMessage;
      this.Service.editMessage = false;
      this.detectChanges('editCancel');
      this.interfaceService.$onCancelEdtMessage.next();
      return true;
    }
  }

  saveMessageDisabled() {
    if (this.Service.editMessage) {
      if (this.Service.type === 'sender') {
        return !this.Service.senderForm.dirty && this.Service.message === this.Service.editMessage.text;
      } else {
        return this.Service.message?.length === 0 || this.Service.message === this.Service.editMessage.text;
      }
    }
    return true;
  }

  saveMessage() {
    if (!this.Service.editMessage) {
      return;
    }
    this.Service.message = this.Service.message.split('\n').join('<br />');
    const arMessage: any = this.Service.editMessage;
    arMessage.chat_id = this.Service.openChatId;
    arMessage.text = this.Service.message?.replace(/<p>/gi, '')?.replace(/<\/p>/gi, '<br>');
    this.Service.saveMessage(arMessage, this.arFiles).subscribe(
      (result: any) => {
        if (this.Service.editMessage) {
          this.Service.editMessage.edit_date = new Date().getTime() / 1000;
          if (arMessage.sender) {
            this.Service.editMessage.sender = result.sender;
          }
          this.Service.editMessage.text = arMessage.text;
        }
        this.Service.message = this.Service.bufferMessage;
        this.Service.editMessage = false;
        this.dcService.detectChanges$.next('message-' + arMessage.id);
        this.senderService.senderAddForm = false;
        this.detectChanges('saveMessage');
      },
      (error) => {
        this.interfaceService.errorHandling(error);
      }
    );
  }

  sendMessage(event: any = false) {
    if (event) {
      event.preventDefault();
    }
    this.focusTextArea();
    const controls = this.FormMessage.controls;
    console.log('Send message start', this.Service.message);
    // Проверяем форму на валидность */
    if (!this.Service.message && this.arFilesCount === 0 && !this.Service.disabledMessageTextarea) {
      // Если форма не валидна, помечаем все контролы как touched **/
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());

      this.notifierWrapService.notify('error', 'Введите ' +
        (this.Service.type === 'sender' ? 'текст рассылки' : 'текст сообщения'));
      log('FormMessage.invalid', this.FormMessage, this.arFilesCount, this.Service.disabledMessageTextarea, this.Service.message);
      this.isSending = false;
      return;
    }
    this.isSending = true;
    const arMessage: SendMessage = {
      chat_id: this.Service.openChatId,
      chat_type: this.Service.openChat.type,
      text: this.Service.message?.replace(/<p>/gi, '')?.replace(/<\/p>/gi, '<br>'),
      attachments: Object.keys(this.arFiles)
    };
    if (this.Service.replyMessage) {
      arMessage.reply_message = this.Service.replyMessage;
    }
    if (this.Service.forwardMessage) {
      arMessage.forward_message = this.Service.forwardMessage;
    }
    this.detectChanges$.next('sendMessage');
    console.log('Send message', this.arFiles, arMessage);
    this.Service.sendMessage(arMessage).subscribe(
      (result: any) => {
        this.cancelReply();
        this.cancelForward();
        this.cancelSpellCheck();
        this.cancelSearchMembers();
        if (this.myDropzone) {
          this.myDropzone.removeAllFiles();
        }
        this.arFiles = {};
        if (this.isMobile) {
          this.interfaceService.showTabsInput$.next(false);
        }
        result.forEach((message: Message) => {
          message.show = true;
          message.service_class = this.Service.type;
          this.allService.newMessage$.next(message);
        });
        this.interfaceService.clearTextArea$.next();
        this.allService.clearDraft(this.Service.openChatId);
        setTimeout(() => {
          this.interfaceService.scrollChat$.next();
        }, 100);
        this.interfaceService.$onCancelAddSender.next();

        this.isSending = false;
        this.detectChanges$.next('POST sendMessage');
      },
      (error) => {
        log('Error sendMessage', error);
        this.isSending = false;
        this.cd.detectChanges();
        this.interfaceService.errorHandling(error);
      }
    );
  }

  cancelReply(): boolean {
    if (this.Service.replyMessage) {
      this.Service.replyMessage = false;
      this.allService.clearReplyDraft(this.Service.openChatId);
      return true;
    }
  }
  cancelForward(): boolean {
    if (this.Service.forwardMessage) {
      this.Service.forwardMessage = false;
      return true;
    }
  }
  startRecord() {
    if (this.isMobile) {
      this.interfaceService.showTabsInput$.next(false);
    }
    this.isRecord = true;
    this.detectChanges('startRecord');
  }

  onCloseVoice() {
    if (this.isRecord) {
      this.isRecord = false;
      this.detectChanges('onCloseVoice');
    }
  }

  createChat() {
    this.allService.setService$.next(this.Service.type);
    this.onNewChat.emit(true);
  }

  searchToggle() {
    if (this.Service.type !== 'sender') {
      this.interfaceService.searchToggle$.next(true);
    }
  }

  scrollToMessage(message: Message) {
    this.interfaceService.scrollToMessage$.next(message);
  }

  toggleMessage(message: Message) {
    if (this.arSelectMessages?.length > 0 || message.force_select) {
      message.select = !message.select;
      if (message.select) {
        this.arSelectMessages.push(message);
      } else {
        const findIndex = this.arSelectMessages.findIndex((v) => v.id === message.id);
        this.arSelectMessages.splice(findIndex, 1);
      }
      this.detectChanges$.next('toggleMessage');
    }
  }

  clearSelectMessages(): boolean {
    if (this.arSelectMessages?.length > 0) {
      this.arSelectMessages = [];
      this.Service.arHistory.map((v) => (v.select = false));
      this.dcService.detectChanges$.next('message');
      this.detectChanges('clearSelectMessages');
      return true;
    }
  }

  forwardSelectMessages() {
    this.modalService.openModal('ModalForwardMessageComponent', {
      Service: this.Service,
      messages: this.arSelectMessages
    });
  }

  deleteSelectMessages() {
    const deleteMessage = (isDeleteAllMessage = false) => {
      this.Service.deleteMessages(this.Service.openChatId, isDeleteAllMessage, this.arSelectMessages.map((v) => v.id)).subscribe(
        (result: any) => {

          this.Service.arHistory
            .filter((v) => v.select)
            .map((v) => {
              v.delete = true;
              v.select = false;
              this.dcService.detectChanges$.next('message-' + v.id);
            });
          this.allService.wsService.wsMessages$.next({
            event: 'delete_messages',
            type: this.Service.type,
            data: {delete_messages: this.arSelectMessages.map((v) => v.id)}
          });
          this.arSelectMessages = [];
          this.detectChanges$.next('deleteSelectMessages');
          this.notifierWrapService.notify('success', 'Сообщения удалены', SnotifyPosition.centerTop);
        },
        (error) => {
          this.interfaceService.errorHandling(error);
        }
      );
    };
    this.snotifyService.clear();
    this.snotifyService.confirm('Вы действительно хотите удалить сообщения?', '', {
      timeout: 30000,
      showProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      position: SnotifyPosition.centerTop,
      buttons: [
        {
          text: 'Да',
          action: () => {
            deleteMessage();
          },
          bold: false
        },
        {
          text: 'Для всех',
          action: () => {
            deleteMessage(true);
          },
          bold: true
        },
        {text: 'Отменить', action: () => log('Clicked: No')}
      ]
    });
    this.notifierWrapService.playAudio('alert');
  }

  editMessageText(message: Message) {
    this.cancelReply();
    this.cancelForward();
    this.allService.clearReplyDraft(this.Service.openChat?.id);
    this.Service.bufferMessage = this.Service.message;
    this.Service.message = message.text.split('<br />').join('\n');
    this.Service.editMessage = message;
    this.interfaceService.$onEdtMessage.next(this.Service.type);
    this.focusTextArea();
    this.detectChanges$.next('editMessageText');
  }

  replyMessageText(message: Message) {
    if (this.arSelectMessages?.length === 0 && this.Service.type !== 'sender') {
      this.interfaceService.focusTextArea$.next(true);
      this.Service.editMessage = false;
      this.Service.replyMessage = message;
      this.allService.saveReplyDraft(this.Service.openChatId, message);
      this.detectChanges$.next('replyMessageText');
    }
  }

  setTextAreaPosition() {
    if (this.interfaceService.messageTextareaType !== 'editor') {
      const element = this.messageText.nativeElement;
      element.focus();
      if (element.selectionStart) {
        this.allService.textAreaPosition = element.selectionStart;
        return;
      }
      this.allService.textAreaPosition = false;
    }

  }

  clickService(type) {
    this.allMessengersService.setServiceActive(type);
    this.onOpenProfile.emit(true);
  }

  get arTyping(): any {
    return this.Service.arTyping.filter((v) => v.user_id === this.Service.openChatId);
  }

  get runChangeDetection() {
    this.allService.arDetectChangesLog.ChatShowComponent++;
    return '';
  }

  openDetailChat() {
    if (this.Service.type !== 'sender') {
      this.modalService.openModal('ModalChatDetailComponent', {
        Service: this.Service,
        id: this.Service.openChatId,
        initData: this.Service.openChat
      });
    }
  }

  get countAccounts(): number {
    return this.allMessengersService.getServicesFilter('isAuth', true)?.length;
  }

  get countShowSlider(): number {
    return (this.countAccounts > 4 ? 4 : this.countAccounts) + 1;
  }

  get sliderWidth(): number {
    return (this.countAccounts > 4 ? 350 : (this.countAccounts + 1) * 80);
  }

  ngOnDestroy() {
    console.error('Destroy carusel');
    this.destroy$.next();
    this.destroy$.complete();
    this.myDropzone?.destroy();
    delete this.myDropzone;
  }

  messageInputClick(): void {
    if (this.interfaceService.isMessageInputAnimate) {
      this.interfaceService.isMessageInputAnimate = false;
      localStorage.setItem('message-animate', 'Y');
      this.cd.detectChanges();
    }
  }

  toggleGrafana() {
    this.interfaceService.openGrafana$.next(!this.interfaceService.openGrafana$.value);
    this.senderService._senderAddForm = !this.interfaceService.openGrafana$.value;
  }

  openDetailInfo(message: Message) {
    this.modalService.openModal('ModalChatDetailComponent', {
      Service: this.Service,
      id: message.from_user.username || message.from_user.id,
      type: 'user'
    });
  }

  private handleOpenChatFromUrl() {
    // Получаем параметры из URL
    const params = new URLSearchParams(window.location.search);
    const chatId = params.get('chatId');

    if (chatId) {
      // Запускаем функцию, если chatId есть
      this.appService.openChat(chatId, 'fellowdesk');
    }
  }
}
